import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useScanManager from 'src/hooks/useScanManager';

const CompanyNameCell = (props: GridCellProps) => {
  const { handleCellClick } = useScanManager();
  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} onClick={handleClick}>
      {props.dataItem[props.field || '']}
    </GridCellBase>
  );
};

export default CompanyNameCell;
